<script setup>
import { computed } from 'vue';
import { isNonEmptyString } from '../../helpers/utilsHelper';

const props = defineProps({
  label: { type: String, required: false, default: null },
  modelValue: { default: null },
  highlight: { type: Boolean, default: false },
  requiredNonNullValue: { type: Boolean, default: false },
  intMode: { type: Boolean, default: false },
  noBottomMargin: { type: Boolean, required: false, default: false }
});

defineEmits(['update:modelValue']);

const inputName = computed(() => `nullable-boolean-picker-${Math.random().toString(36).slice(2)}`);
</script>

<template>
  <div class="form-group" :class="props.noBottomMargin ? 'mb-0' : ''">
    <label
      v-if="isNonEmptyString(props.label)"
      class="col-form-label pt-0"
      :class="highlight ? 'text-warning' : ''"
    >
      {{ props.label }}
    </label>

    <div class="btn-group btn-group-toggle" style="display: block">
      <label
        class="btn btn-sm btn-white"
        :class="props.modelValue == null ? 'active' : ''"
        style="cursor: pointer"
      >
        <input
          type="radio"
          :value="null"
          :checked="props.modelValue == null"
          @change="$emit('update:modelValue', null)"
        />
        -
      </label>
      <label
        class="btn btn-sm btn-white"
        :class="props.modelValue === true || props.modelValue === 1 ? 'active' : ''"
        style="cursor: pointer"
      >
        <input
          type="radio"
          :name="inputName"
          :required="props.requiredNonNullValue"
          :value="true"
          :checked="props.modelValue === true || props.modelValue === 1"
          @change="$emit('update:modelValue', props.intMode ? 1 : true)"
        />
        Tak
      </label>
      <label
        class="btn btn-sm btn-white"
        :class="props.modelValue === false || props.modelValue === 0 ? 'active' : ''"
        style="cursor: pointer"
      >
        <input
          type="radio"
          :name="inputName"
          :value="false"
          :checked="props.modelValue === false || props.modelValue === 0"
          @change="$emit('update:modelValue', props.intMode ? 0 : false)"
        />
        Nie
      </label>
    </div>
  </div>
</template>
